module.exports = __webpack_public_path__ + "assets/media/day22.d4eccfda.mp3";